/* eslint-disable max-len */
import React, {FC} from "react"

import id from "@irati/utils/id"

import BaseSvgIcon from "./Base"

interface Props {
  id?: string
  title?: string
}

const SummaryComments: FC<Props> = (props) => {
  const titleId = id("title", props)
  const {title, ...rest} = props

  return (
    <BaseSvgIcon {...rest} aria-labelledby={titleId}>
      <path
        d="m8.04545455 12.1623685c-2.57958956-.3543481-4.54545455-2.1167124-4.54545455-4.29873214 0-2.4588528 2.48780797-4.36363636 5.5-4.36363636 3.012192 0 5.5 1.90478356 5.5 4.36363636 0 .88681922-.330241 1.7365787-.8969374 2.39257064-.0393547.063382-.0863101.1224262-.1402809.176397l-.1134428.1133815c-.0216611.0219926-.0216611.0219926-.036541.0369415-.0002202.0002201-.0002202.0002201-.0004404.00044-.0133225.0132408-.0133225.0132408-.0285772.0282384l-3.60881474 3.6088147c-.60133009.6013301-1.62951101.1754436-1.62951101-.6749656z"
        fill="#00adee"
        stroke="#3d3d36"
      />
    </BaseSvgIcon>
  )
}

SummaryComments.defaultProps = {
  id: "summary-comments-icon",
  title: "Comments"
}

export default SummaryComments
